import request from './request';

export function getCommunity(params){
  return request('get', `/apiv2/community`, params);
}